import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://umooov.info";
const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1558642084-fd07fae5282e?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&fit=crop&q=85";

// Dynamic per-page SEO: title, meta description, canonical, Open Graph/Twitter, optional JSON-LD.
export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd }) => {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="UMoooV" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
